(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CommentsComponentController', CommentsComponentController);

    CommentsComponentController.$inject = ['$scope'];

    function CommentsComponentController($scope) {
        var vm = this;

        vm.init = init();

        function init() {
            console.log('========= COMMENTS =========');
        }
    }
})();
